import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { userRoleNameSelector } from '../../../../redux/modules/user/selectors';

const CAN_ACCESS_INSIGHTS_QUERY_KEY = ['canAccessInsights'] as const;

export const useReportingFlags = () => {
  const userRole = useSelector(userRoleNameSelector);

  const { data, isLoading, isError } = useQuery({
    queryKey: CAN_ACCESS_INSIGHTS_QUERY_KEY,
    queryFn: () => api.request(endpoints.internal.canAccessInsights()),
    select: ({ canAccessInsights }) => canAccessInsights,
    staleTime: Infinity,
  });
  const hasUserAccess = [
    'admin',
    'organization_group_admin',
    'manager',
    'empowered_manager',
  ].includes(userRole);

  if (isLoading || isError)
    return {
      isReportingEnabled: false,
      isLoading,
      isError,
    };

  return {
    isReportingEnabled: data === true && hasUserAccess,
    isLoading: false,
    isError: false,
  };
};
